import MainLayout from "../layout/main";
import photo from "../asset/img/dashboard.svg";

export default function HomePage() {
	return (
		<MainLayout pageTitle="Trang Chủ">
			<img
				src={photo}
				alt="Dashboard"
				style={{ maxWidth: "50%", display: "block", margin: "auto" }}
			/>
		</MainLayout>
	);
}
